import { render, staticRenderFns } from "./NewFolderModal.vue?vue&type=template&id=0f8f7e6c&"
import script from "./NewFolderModal.vue?vue&type=script&lang=js&"
export * from "./NewFolderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports